import axios from "axios";
import { api } from "../config";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const token = JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null;
if (token)
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;

// In-flight request counter; broadcast to GlobalLoadingBar via window event.
let inFlightCount = 0;
const notifyLoading = () => {
  if (typeof window !== "undefined" && typeof CustomEvent === "function") {
    window.dispatchEvent(new CustomEvent("axios-loading", { detail: { count: inFlightCount } }));
  }
};
const decrementInFlight = () => {
  if (inFlightCount > 0) inFlightCount--;
  notifyLoading();
};

axios.interceptors.request.use(
  function (config) {
    inFlightCount++;
    notifyLoading();
    return config;
  },
  function (error) {
    decrementInFlight();
    return Promise.reject(error);
  }
);

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    decrementInFlight();
    return response.data ? response.data : response;
  },
  function (error) {
    decrementInFlight();
    const status = error.response && error.response.status;
    let message;
    switch (status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
      case 403: {
        // Token expired / invalid — clear auth and bounce to login.
        // Only bounce if the user actually had a session (token present). Anonymous
        // visitors on public/dashboard-public pages (e.g. /pricing) may hit auth-only
        // endpoints; for them just reject and let the caller handle it — don't redirect.
        let hasToken = false;
        try {
          const authUser = JSON.parse(localStorage.getItem("authUser"));
          hasToken = !!(authUser && authUser.token);
        } catch (e) { hasToken = false; }
        // Skip when already on /login to avoid redirect loops on bad-credentials errors.
        const onLoginPage = typeof window !== "undefined" &&
          window.location && window.location.pathname &&
          window.location.pathname.indexOf("/login") === 0;
        if (hasToken && !onLoginPage) {
          try { localStorage.removeItem("authUser"); } catch (e) { }
          delete axios.defaults.headers.common["Authorization"];
          if (typeof window !== "undefined") {
            window.location.href = "/login";
          }
        }
        message = status === 401 ? "Session expired. Please log in again." : "Forbidden";
        break;
      }
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = (error.response && error.response.data && error.response.data.message) || error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = () => {

const tokenTmp = JSON.parse(localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser")).token : null; 
  // console.log("token", token)
  axios.defaults.headers.common["Authorization"] = "Bearer " + tokenTmp;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    // console.log(url)
    
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }
    // console.log(response)
    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };